<template>
  <!-- <b-nav-item @click="skin = isDark ? 'light' : 'dark'">
    <feather-icon
      size="21"
      :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
    />
  </b-nav-item> -->
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <font-awesome-icon :icon="currentTheme.faicon" />
      <span class="ml-50 text-body">{{ currentTheme.name }}</span>
    </template>
    <b-dropdown-item
      v-for="theme in themes"
      :key="theme.theme"
      @click="skin = theme.theme"
    >
      <font-awesome-icon :icon="theme.faicon" />
      <span class="ml-50 text-body">{{ theme.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import useAppConfig from "@core/app-config/useAppConfig";
// import { computed } from "vue";
import { BNavItemDropdown, BDropdownItem } from "bootstrap-vue";

export default {
  components: {
    // BNavItem,
    BNavItemDropdown,
    BDropdownItem,
  },
  computed: {
    currentTheme() {
      return this.themes.find((t) => t.theme === this.skin);
    },
  },
  setup() {
    const themes = [
      { theme: "light", faicon: "sun", name: "Claro" },
      { theme: "dark", faicon: "moon", name: "Oscuro" },
      { theme: "bordered", faicon: "border-style", name: "Bordeado" },
      { theme: "semi-dark", faicon: "adjust", name: "Semi Claro" },
    ];

    // const { skin } = useAppConfig()
    // const isDark = computed(() => skin.value === 'dark')
    // return { skin, isDark }
    const { skin } = useAppConfig();
    return { themes, skin };
  },
};
</script>
